import React from 'react';
import {
  Button,
  Alert,
  Box
} from '@mui/material';
import BaseModal from './common/BaseModal';

const ErrorModal = ({
  open,
  onClose,
  title = 'Error',
  message = 'An error occurred',
  allowHtml = false
}) => {
  const actions = (
    <Button 
      onClick={onClose}
      variant="contained"
      sx={{ 
        textTransform: 'none',
        minWidth: { xs: 'auto', sm: '100px' }
      }}
    >
      OK
    </Button>
  );

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={title}
      size="small"
      maxWidth="sm"
      actions={actions}
    >
      <Box sx={{ minWidth: { xs: '250px', sm: '300px' } }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {allowHtml ? (
            <div dangerouslySetInnerHTML={{ __html: message }} />
          ) : (
            message
          )}
        </Alert>
      </Box>
    </BaseModal>
  );
};

export default ErrorModal;
